import { Injectable } from '@angular/core';

@Injectable({
  providedIn: 'root',
})
export class ClipboardService {
  copyToClipboard(data: string, message: string): void {
    if (!navigator.clipboard) {
      console.log('Your browser doesn`t support copy');
      return;
    }
    navigator.clipboard.writeText(data).then(
      // () => this.notificationService.success(message),
      () => console.log('Copied to clipboard', message),
      err => console.error('Async: Could not copy text: ', err)
    );
  }
}
